export const OPEN_LOADER = "OPEN_LOADER"
export const CLOSE_LOADER ="CLOSE_LOADER"